module.exports = __webpack_public_path__ + "img/red.a08362f5.png";